import { NgModule } from "@angular/core";
import { AdminCommonModule } from "../admin-common.module";
import { CustomerManagementComponent } from "./customer-management.component";
import { CustomerManagementTableComponent } from "./customer-management-table.component";
import {CollapsibleModule} from 'angular2-collapsible';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomerMergeComponent } from "./customer-merge.component";

@NgModule({
    declarations: [
        CustomerManagementComponent,
        CustomerManagementTableComponent,
        CustomerMergeComponent
    ],
    imports: [
        AdminCommonModule,
        CollapsibleModule,
        BrowserAnimationsModule
    ]
})
export class CustomerModule {
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/customer/customer.module.ts